import React, { useEffect, useState } from 'react';
import './LoginMenuModal.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Font Awesome icons

import { useData } from './AuthContext';


const LoginMenuModal = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingIn, setIsFadingIn] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' or 'register'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const { isLoggedIn, login, logout, user } = useData();

  // Animate modal open/close
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      const timeout = setTimeout(() => setIsFadingIn(true), 10);
      return () => clearTimeout(timeout);
    } else {
      setIsFadingIn(false);
      const timeout = setTimeout(() => {
        setIsVisible(false);
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  const handleSwitchMode = () => {
    setMode(prev => (prev === 'login' ? 'register' : 'login'));
    setError('');
    setSuccess('');
  };

  const handleLogout = () => {
    logout();
    setSuccess('Logged out.');
    setMode('login');
    setEmail('');
    setPassword('');
    setUsername('');
  };


  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      if (mode === 'login') {
        // JWT Auth login
        const response = await fetch('https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/jwt-auth/v1/token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: email, password }),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || 'Login failed');
        }
        login({ email }, data.token);
        setSuccess('Logged in!');
      } else {
        // Register
        const response = await fetch('https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/custom/v1/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, email, password }),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || 'Registration failed');
        }
        setSuccess('Registered! You can now login.');
        setMode('login');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };


    const forgotPassword = async () => {
      if (!email) {
        alert('Please enter your email address to reset your password.');
        return;
      }

      try {
        const response = await fetch('https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/custom/v1/reset-password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email || username }),
        });

        const data = await response.json();

        if (response.ok && data.success) {
          alert('Check Your Email, Password reset instructions have been sent.');
        } else {
          alert('Error', data.message || 'Failed to send reset link');
        }
      } catch (error) {
        console.error('Forgot password error:', error);
        alert('Something went wrong. Please try again later.');
      }
    };

  return (
    <div className={`login-menu-modal-overlay ${isFadingIn ? 'fade-in' : 'fade-out'}`}>
      <div className="login-menu-modal">
        <div className='login-input-container'>
          <button className="login-close-button" onClick={onClose}>&times;</button>
          {isLoggedIn ? (
            <>
              <h4>Welcome! {user.email}</h4>
              {success && <div className="success-message">{success}</div>}
            </>
          ) : (
            <>
              <h2>{mode === 'login' ? 'Login' : 'Sign Up'}</h2>
              <div className='toggle-mode'>
                {mode === 'login' ? (
                  <>
                    <p>
                      Don't have an account?{' '}
                      <a onClick={handleSwitchMode} >Register</a>
                    </p>
                  </>
                ) : (
                  <>
                    <p>Create an account to access your calculations on all your devices.</p>
                    <p>
                      Already have an account?{' '}
                      <a onClick={handleSwitchMode} >Login</a>
                    </p>
                  </>
                )}
              </div>
              <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                {mode === 'register' && (
                  <div>
                    <label>Username</label>
                    <input
                      className='register-username-input'
                      placeholder='Username'
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                )}
                <div>
                  <label>Email</label>
                  <input
                    className='login-email-input'
                    placeholder='Email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label>Password</label>
                  <div className="password-input-wrapper">
                    <input
                      className='login-password-input'
                      placeholder='Password'
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="toggle-password-button"
                      onClick={() => setShowPassword(prev => !prev)}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
              </div>

              {mode === 'login' && (
                <div onClick={forgotPassword} style={{width: "100%", alignItems: "flex-end", marginTop: "10px", cursor:"pointer", textAlign: "end"}}>
                    <div style={{color: '#333'}}>
                      Forgot Password
                    </div>
                </div>
              )}
              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}
              <button
                className='login-button'
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Please wait...' : mode === 'login' ? 'Login' : 'Register'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginMenuModal;
